<template>
  <v-card class="text-xs-center">
    <h1 class="text-pagename">Role information</h1>

    <RoleForm @setDialog="dialog = $event" :dialog="dialog"></RoleForm>

    <v-btn
      icon
      @click="$router.push({path:'/weserve_admin_login/-/rolemanage'})"
      style="position:absolute;left:10px;top:0px;"
    >
      <v-icon>arrow_back</v-icon>
    </v-btn>

    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card-text style="height: auto;">
        <v-layout row>
          <v-flex xs4>
            <v-text-field hide-details v-model="form.role_name" label="Role name" color="black"></v-text-field>
          </v-flex>
          <v-flex xs8>
            <v-btn @click="dialog = true">
              <v-icon>add</v-icon>add new province
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text style="height: auto;">
        <RoleDetailTable></RoleDetailTable>
      </v-card-text>
    </v-form>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red" flat @click="$emit('setDialog', false)">Cancel</v-btn>
      <v-btn color="green" flat>Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import RoleDetailTable from "@/components/back-office/Role/RoleDetailTable.vue";
import RoleForm from "@/components/back-office/Role/RoleForm.vue";
export default {
  components: {
    RoleForm,
    RoleDetailTable
  },
  data() {
    return {
      dialog: false,
      valid: true,
      role_name: "",
      ex_service: ["1", "2", "3", "4"],
      mocking_service: [
        {
          id: 1,
          name: "Food delivery"
        },
        {
          id: 2,
          name: "Messenger"
        },
        {
          id: 3,
          name: "Point of sale"
        },
        {
          id: 4,
          name: "Rider"
        }
      ],
      mocking_province: [
        { id: 1, name: "Phuket" },
        { id: 2, name: "Surathani" }
      ],
      form: {}
    };
  },
  computed: {},
  created() {
    this.form = {
      role_id: 1,
      role_name: "root",
      provinces: [
        {
          province_id: 66,
          province_name: "phuket",
          dashboards: [
            {
              dashboard_id: 1,
              dashboard_name: "order",
              permission: "read"
            },
            {
              dashboard_id: 1,
              dashboard_name: "control_panel",
              services: [
                {
                  service_id: 1,
                  service_name: "Food Delivery",
                  permission: "read"
                },
                {
                  service_id: 2,
                  service_name: "Point of Sale",
                  permission: "read"
                },
                {
                  service_id: 3,
                  service_name: "Messenger",
                  permission: "read"
                },
                {
                  service_id: 4,
                  service_name: "Rider",
                  permission: "read"
                }
              ]
            }
          ]
        }
      ]
    };
  }
};
</script>





